module.exports = __webpack_public_path__ + "media/images/case_studies/comme_j_aime/flexible_tracking-9e9d901c1e829679fdffe234aa5a0168.svg";